import * as Yup from 'yup';

import { ConverterPositionItem } from './models/internal/converter-positionItem';
import { TransitionTarget } from './models/internal/transition-target';

export const validationSchema = Yup.object().shape({
    selectedTarget: Yup.number().required('app.error.required'),
    deliveryDate: Yup.date().when('hasDeliveryDate', {
        is: true,
        then: Yup.date().typeError('app.error.required').required('app.error.required'),
        otherwise: Yup.date().nullable(),
    }),
    deliveryDateType: Yup.string().when('hasDeliveryDate', {
        is: true,
        then: Yup.string().required('app.error.required'),
        otherwise: Yup.string().nullable(),
    }),

    // For inquiries there is only quantity validation is needed
    customers: Yup.array().when('selectedTarget', {
        is: (target: number) => target !== TransitionTarget.Inquiry,
        then: Yup.array().of(
            Yup.object().shape({
                customerSuppliers: Yup.array().of(
                    Yup.object().shape({
                        deliveryPrice: Yup.number().when('items', {
                            is: (items: ConverterPositionItem[]) => items.some(item => item.isSelected),
                            then: Yup.number().required('app.error.required').min(0, 'app.error.positive'),
                        }),
                        surcharge: Yup.number().when('items', {
                            is: (items: ConverterPositionItem[]) => items.some(item => item.isSelected),
                            then: Yup.number().required('app.error.required'),
                        }),
                        items: Yup.array().of(
                            Yup.object().shape({
                                isSelected: Yup.boolean(),
                                price: Yup.number().when('isSelected', {
                                    is: true,
                                    then: Yup.number().typeError('app.error.required').required('app.error.required'),
                                }),
                                quantity: Yup.number().when('isSelected', {
                                    is: true,
                                    then: Yup.number()
                                        .moreThan(0, 'app.error.greaterZero')
                                        .required('app.error.required')
                                        .typeError('app.error.required'),
                                }),
                            })
                        ),
                    })
                ),
            })
        ),
        otherwise: Yup.array().of(
            Yup.object().shape({
                customerSuppliers: Yup.array().of(
                    Yup.object().shape({
                        items: Yup.array().of(
                            Yup.object().shape({
                                isSelected: Yup.boolean(),
                                quantity: Yup.number().when('isSelected', {
                                    is: true,
                                    then: Yup.number()
                                        .moreThan(0, 'app.error.greaterZero')
                                        .required('app.error.required')
                                        .typeError('app.error.required'),
                                }),
                            })
                        ),
                    })
                ),
            })
        ),
    }),
});
